import React from "react";
import { CheckCircle2, CalendarDays } from "lucide-react";
import { EVENT } from "../../lib/data";

export const PostmarkSuccess = ({ title, message, onReset, resetLabel = "Submit Another" }) => (
  <div className="flex flex-col items-center text-center py-10 px-4" data-testid="form-success">
    <div className="postmark animate-stamp-in w-40 h-40 flex flex-col items-center justify-center mb-6">
      <CheckCircle2 size={40} className="mb-1" />
      <span className="text-[0.6rem] leading-tight">Pak Fest 2026</span>
      <span className="text-[0.6rem] leading-tight">· Received ·</span>
    </div>
    <h3 className="font-display font-bold text-forest text-3xl mb-2">{title}</h3>
    <p className="text-sm text-forest-light max-w-md mb-4">{message}</p>
    <div className="flex items-center gap-2 border-2 border-dashed border-forest/50 px-4 py-2 mb-6" data-testid="success-event-details">
      <CalendarDays size={18} className="text-rust" />
      <span className="text-sm font-semibold text-forest">{EVENT.dateLabel} · {EVENT.timeLabel}</span>
    </div>
    {onReset && (
      <button onClick={onReset} className="btn-ghost px-6 py-3 text-sm" data-testid="form-reset-btn">{resetLabel}</button>
    )}
  </div>
);

export const Field = ({ label, children, required }) => (
  <div className="flex flex-col gap-1">
    <label className="field-label">{label}{required && <span className="text-rust"> *</span>}</label>
    {children}
  </div>
);
